import { BaseEntity, getCachedStructureEntity } from ".";
import { IGet_corporations_corporation_id_wallets_division_transactions_200_ok } from "../service/esiclient";
import { getCachedStationEntity } from "./StationEntityCache";
import moment from "moment";
//import { getCachedAssetEntity } from "./AssetEntityCache";

export class CorporationWalletTransactionEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Transaction";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_corporations_corporation_id_wallets_division_transactions_200_ok> = this.props;
    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Id
      delete entity.properties["transaction_id"];
      // - Text and Image
      if (entity.properties["type"]) {
        const typeEntity = entity.properties["type"] as Excel.EntityCellValue;
        if (typeEntity && typeEntity.properties) {
          // Text
          entity.text = typeEntity.properties.name.basicValue as string;
          // Image
          if (Object.prototype.hasOwnProperty.call(typeEntity.properties, "image")) {
            entity.properties["image"] = typeEntity.properties["image"];
          }
        }
      }
      if (props.date) {
        const date = moment(props.date);
        entity.properties["date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      // - Location
      if (props.location_id) {
        const stationEntity = await getCachedStationEntity(props.location_id);
        if (stationEntity !== null) {
          entity.properties["location"] = await stationEntity.toJson(true);
          delete entity.properties["location_id"];
        } else {
          const structureEntity = await getCachedStructureEntity(props.location_id, this._character_id);
          if (structureEntity !== null) {
            entity.properties["location"] = await structureEntity.toJson(true);
            delete entity.properties["location_id"];
          }
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        // title: { property: "name" },
      },
    };

    // - Image
    if (
      entity.layouts &&
      entity.layouts.card &&
      entity.properties &&
      Object.prototype.hasOwnProperty.call(entity.properties, "image")
    ) {
      entity.layouts.card.mainImage = { property: "image" };
    }

    return entity;
  }
}
